import { IsString, MaxLength } from 'class-validator';

export class AbilityPricelistSearchDTO {

    @IsString()
    @MaxLength(50)
    name: string;

}
